import React from "react";
import { Link } from "react-router-dom";
import { Radio, Radar as RadarIcon, Zap, Users, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { SITE } from "../config";

const About = () => (
  <div className="max-w-5xl mx-auto px-6 pt-10">
    <div className="text-[11px] mono uppercase tracking-widest text-cyan-400">About Us</div>
    <h1 className="display-italic text-4xl sm:text-6xl mt-2 max-w-3xl uppercase sd-title-gradient">We chase storms so you can stay ahead of them.</h1>
    <p className="text-slate-300 text-lg mt-5 max-w-3xl leading-relaxed">
      {SITE.name} is a 24/7 severe-weather broadcast network built by storm chasers and weather enthusiasts.
      From tornado-warned supercells across Tornado Alley to landfalling hurricanes on the Gulf,
      we deliver first-person coverage the moment nature turns hostile.
    </p>
    <div className="grid md:grid-cols-3 gap-4 mt-10">
      {[
        { icon: Radio, title: "Live 24/7", desc: "Non-stop live coverage streamed simultaneously to our site, YouTube, TikTok, Instagram, and Facebook." },
        { icon: RadarIcon, title: "Storm Desk Radar", desc: "WeatherWise-style interactive radar with high-res forecast models from Pivotal Weather." },
        { icon: Zap, title: "Real-time Alerts", desc: "NWS watches and warnings surfaced the moment they're issued, right on the home page." },
      ].map((f,i)=>(
        <div key={i} className="glass rounded-xl p-6">
          <f.icon className="w-7 h-7 text-red-400" />
          <div className="display font-bold text-lg mt-3">{f.title}</div>
          <p className="text-sm text-slate-400 mt-2">{f.desc}</p>
        </div>
      ))}
    </div>

    <div className="mt-14 glass rounded-2xl p-8 md:p-10 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-red-500/15 blur-3xl" />
      <div className="relative grid md:grid-cols-[1fr_auto] gap-6 items-center">
        <div>
          <div className="text-[11px] mono uppercase tracking-widest text-red-400 flex items-center gap-1.5"><Users className="w-3.5 h-3.5" /> Our mission</div>
          <h2 className="display text-2xl font-bold mt-1">Save lives with information.</h2>
          <p className="text-slate-300 mt-3 max-w-2xl">Severe weather is unforgiving — but with the right eyes, the right radar, and the right nowcast, communities can act in time. That's why we exist.</p>
        </div>
        <Link to="/contact"><Button className="bg-red-600 hover:bg-red-500 text-white h-11 px-6 gap-2"><Mail className="w-4 h-4" /> Contact us</Button></Link>
      </div>
    </div>
  </div>
);

export default About;
